import React from "react";
import PageSEO from "../../../../Components/SEO/PageSEO";

// Import Components
import HeroComponent from "../../../../Layout/Components/HeroComponent/HeroComponent";
import ServerTypeIntro from "../../../../Components/ServerTypeIntro/ServerTypeIntro";

// Import Assets
import StandardServerGroup from "../../../../Assets/Standard_Server.png";
import CustomServerGroup from "../../../../Assets/Custom_Server.png";
import GPU_Enabled_Server_Group from "../../../../Assets/AI_Capable_Server.png";
import StorageServerGroup from "../../../../Assets/Storage_Server.png";

// Import Animations
import FadeInOnScroll from "../../../../util/Animations/FadeInOnScroll";

const AllDedicatedServersPage = () => {
  // Define structured data for the page
  const serverTypesSchema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "item": {
          "@type": "Product",
          "name": "Standard Dedicated Servers",
          "description": "High-performance standard dedicated servers, providing unparalleled control, security, and reliability for your business needs.",
          "url": "https://webnx.com/standard-dedicated-servers"
        }
      },
      {
        "@type": "ListItem",
        "position": 2,
        "item": {
          "@type": "Product",
          "name": "Custom Dedicated Servers",
          "description": "Custom-built dedicated servers designed to meet your exact requirements, providing optimized performance for demanding workloads.",
          "url": "https://webnx.com/custom-dedicated-servers"
        }
      },
      {
        "@type": "ListItem",
        "position": 3,
        "item": {
          "@type": "Product",
          "name": "GPU-Enabled Dedicated Servers",
          "description": "GPU-enabled dedicated servers perfect for AI, machine learning, rendering, and scientific computations.",
          "url": "https://webnx.com/gpu-enabled-servers"
        }
      },
      {
        "@type": "ListItem",
        "position": 4,
        "item": {
          "@type": "Product",
          "name": "Storage Dedicated Servers",
          "description": "Scalable, secure solutions for managing high-volume data, backups, and media storage for businesses of all sizes.",
          "url": "https://webnx.com/storage-servers"
        }
      }
    ]
  };

  return (
    <div>
      <PageSEO
        title="All Dedicated Servers | High-Performance Server Solutions by WebNX"
        description="Explore WebNX's comprehensive range of dedicated servers, including standard, custom-built, GPU-enabled, and storage solutions. Tailored server configurations with enterprise-grade hardware and 24/7 support."
        keywords="dedicated servers, custom servers, GPU-enabled servers, storage servers, WebNX hosting solutions, enterprise servers, high-performance servers, server hosting, dedicated hosting, bare metal servers"
        path="/all-dedicated-servers"
        image="https://webnx.com/assets/dedicated-servers.jpg"
        schema={serverTypesSchema}
        socialProfiles={{
          facebook: "https://www.facebook.com/WebNX/",
          linkedin: "https://www.linkedin.com/company/webnx/"
        }}
      />

      {/* Hero Section */}
      <HeroComponent
        title="All Dedicated Servers"
        subtitle="Learn About Our <br /> Dedicated Servers"
        buttonText1="Shop Servers Now"
        buttonLink1="#filterComponent"
        showButton1={false}
        buttonText2="More Information"
        buttonLink2="#moreInfo"
        showButton2={false}
      />

      {/* Standard Dedicated Servers Section */}
      <FadeInOnScroll>
        <ServerTypeIntro
          header="Standard <br/> Dedicated Servers"
          subheader="Dedicated Servers"
          text="WebNX offers high-performance standard dedicated servers, providing unparalleled control, security, and reliability for your business needs."
          image={StandardServerGroup}
          showButton={true}
          buttonText="Learn More"
          buttonLink="/standard-dedicated-servers"
        />
      </FadeInOnScroll>

      {/* Custom Dedicated Servers Section */}
      <FadeInOnScroll>
        <ServerTypeIntro
          header="Custom <br />Dedicated Servers"
          subheader="Tailored Solutions to Fit Every Unique Need"
          text="WebNX's custom-built dedicated servers are designed to meet your exact requirements, providing optimized performance for demanding workloads."
          image={CustomServerGroup}
          showButton={true}
          buttonText="Learn More"
          buttonLink="/custom-dedicated-servers"
          reverse={true}
        />
      </FadeInOnScroll>

      {/* GPU-Enabled Dedicated Servers Section */}
      <FadeInOnScroll>
        <ServerTypeIntro
          header="GPU Enabled<br /> Dedicated Servers"
          subheader="Harness the Power of GPU-Accelerated Computing"
          text="Accelerate your applications with WebNX's GPU-enabled dedicated servers, perfect for AI, machine learning, rendering, and scientific computations."
          image={GPU_Enabled_Server_Group}
          showButton={true}
          buttonText="Learn More"
          buttonLink="/gpu-enabled-servers"
        />
      </FadeInOnScroll>

      {/* Storage Dedicated Servers Section */}
      <FadeInOnScroll>
        <ServerTypeIntro
          header="Storage <br /> Dedicated Servers"
          subheader="Scalable Storage Solutions"
          text="WebNX's storage servers provide scalable, secure solutions for managing high-volume data, backups, and media storage for businesses of all sizes."
          image={StorageServerGroup}
          showButton={true}
          buttonText="Learn More"
          buttonLink="/storage-dedicated-servers"
          reverse={true}
        />
      </FadeInOnScroll>
    </div>
  );
};

export default AllDedicatedServersPage;
